// You can write more code here

/* START OF COMPILED CODE */

import LaneEntityImage from './LaneEntityImage';
/* START-USER-IMPORTS */
import { BodyTypes } from '../LevelManager';
import { Passenger } from '../Passenger';
import { Driver, Vehicle } from './../../Vehicle';
import WaitingPassenger from './../WaitingPassenger';
import GameUI from '../../scenes/GameUI';
/* END-USER-IMPORTS */

export default class TaxiRank extends LaneEntityImage {
  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 125.5, y ?? 185.5, texture || 'game', frame ?? 'taxi_rank.png');

    /* START-USER-CTR-CODE */
    this.hasPassenger = false;
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */
  protected hasPassenger: boolean;
  protected waitingPassenger: WaitingPassenger | undefined;
  protected passenger: Passenger | undefined;

  public init() {
    (this.body as MatterJS.BodyType).label = BodyTypes.TaxiRank;
    (this.body as MatterJS.BodyType).onCollideCallback = this.onCollisionStart.bind(this);
  }

  public setPassenger(waitingPassenger: WaitingPassenger, passenger: Passenger) {
    this.waitingPassenger = waitingPassenger;
    this.passenger = passenger;
    this.hasPassenger = true;
  }

  public pickupPassenger(): boolean {
    if (this.hasPassenger) {
      this.hasPassenger = false;
      return true;
    }

    return false;
  }

  protected onCollisionStart(pair: MatterJS.ICollisionPair) {
    if (!this.hasPassenger || !this.passenger) return;

    if ((pair.bodyA as MatterJS.BodyType).label == BodyTypes.Vehicle && (pair.bodyB as MatterJS.BodyType).label == BodyTypes.TaxiRank) {
      this.onVehicleCollisionStart(pair, pair.bodyA as MatterJS.BodyType, pair.bodyB as MatterJS.BodyType);
    } else if ((pair.bodyB as MatterJS.BodyType).label == BodyTypes.Vehicle && (pair.bodyA as MatterJS.BodyType).label == BodyTypes.TaxiRank) {
      this.onVehicleCollisionStart(pair, pair.bodyB as MatterJS.BodyType, pair.bodyA as MatterJS.BodyType);
    }
  }

  protected onVehicleCollisionStart(pair: MatterJS.ICollisionPair, vehicle: MatterJS.BodyType, taxiRank: MatterJS.BodyType) {

    if (vehicle.gameObject instanceof Vehicle && vehicle.gameObject.IsTaxi && vehicle.gameObject.DriverProfile.driver == Driver.PlayerTaxi && this.hasPassenger && this.passenger) {
      vehicle.gameObject.pickupPassenger(this.passenger);

      this.scene.events.emit(
        GameUI.events.Pickup,
        this.x - this.scene.cameras.main.scrollX,
        (this.waitingPassenger?.IconY ?? 700) - this.scene.cameras.main.scrollY,
        this.passenger.Icon,
        vehicle.gameObject,
        this.passenger.PickupBonus
      );
      this.waitingPassenger?.pickup();
      this.passenger = undefined;
      this.hasPassenger = false;
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
